import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CookieService } from '../services/cookie-service/cookie.service';
import { AppLoadingService } from '../services/app-loading.service';
import { AuthService } from '../services/auth-service/auth.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {
    constructor(
        private cookieService: CookieService,
        private router: Router,
        private appLoading: AppLoadingService,
        private authService: AuthService
    ) {}

    canActivate(): Observable<boolean> | boolean { return this.checkSession(); }
    canActivateChild(): Observable<boolean> | boolean { return this.checkSession(); }

    private checkSession(): Observable<boolean> | boolean {
        // ptr_session est posé par le serveur au login — readable par JS (non-HttpOnly)
        if (this.cookieService.hasSession()) return true;

        // Session absente ou tampered — appeler logout backend pour effacer ptr_auth_token (HttpOnly)
        this.cookieService.removeCookies();
        this.appLoading.hide();

        return this.authService.LogOutUser().pipe(
            map(() => { this.router.navigate(['/login']); return false; }),
            catchError(() => { this.router.navigate(['/login']); return of(false); })
        );
    }
}
